module.exports = __webpack_public_path__ + "img/846.ee81fcf0.png";